import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowUpwardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_upward"}/>
}
